import { FC } from 'react';

import { useAccountIsAuthorized } from 'application/hooks';

import SmartLayout from '../SmartLayout';
import CleanLayout from '../CleanLayout';

const SwitchLayout: FC = () => {
  const isAuthorized = useAccountIsAuthorized();

  if (isAuthorized) {
    return <SmartLayout />;
  }

  return <CleanLayout />;
};

export default SwitchLayout;
